<template>
<!-- Generator: Adobe Illustrator 19.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<rect x="437.723" y="193.947" width="34.607" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="39.667" y="193.947" width="373.65" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<path d="M73.508,263.865v127.59h95.984v-127.59H73.508z M154.508,376.471H88.493V278.85h66.015V376.471z"/>
	</g>
</g>
<g>
	<g>
		<path d="M342.508,391.455h95.984v-127.59h-95.984V391.455z M357.492,278.85h66.015v97.621h-66.015V278.85z"/>
	</g>
</g>
<g>
	<g>
		<rect x="129.005" y="323.093" width="14.984" height="37.331"/>
	</g>
</g>
<g>
	<g>
		<rect x="129.005" y="294.093" width="14.984" height="19.894"/>
	</g>
</g>
<g>
	<g>
		<rect x="398.005" y="321.095" width="14.984" height="39.329"/>
	</g>
</g>
<g>
	<g>
		<rect x="398.005" y="294.093" width="14.984" height="17.896"/>
	</g>
</g>
<g>
	<g>
		<rect y="496.741" width="14.5" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<path d="M486.741,496.749L486.741,496.749v-36.022h-10.916V233.12h21.166v-63.99h-17.166v-46.197h-79.271
			C389.069,52.543,328.069,0.266,256,0.266S122.931,52.543,111.446,122.933H32.174v46.197H15.008v63.99h21.166v227.608H25.259
			v51.006H512v-14.984H486.741z M47.159,137.918H158v-14.984h-31.341C137.957,60.981,192.135,15.251,256,15.251
			s118.043,45.73,129.34,107.683h-57.008v14.984H464.84v31.212H47.159V137.918z M29.993,218.136v-34.021h452.015v34.021H29.993z
			 M256,254.691c-33.907,0-61.492,27.585-61.492,61.493v144.543H51.159V233.12H460.84v227.608H317.492V316.184
			C317.492,282.277,289.907,254.691,256,254.691z M302.508,316.184v144.543h-39.015V270.288
			C285.585,273.882,302.508,293.09,302.508,316.184z M248.508,270.288v190.439h-39.015V316.184
			C209.492,293.09,226.415,273.882,248.508,270.288z M471.757,496.748H40.243v-21.037h431.514V496.748z"/>
	</g>
</g>
<g>
	<g>
		<rect x="67.06" y="84.042" width="31.987" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="20.937" y="84.042" width="34.084" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="412.949" y="84.042" width="42.046" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="465.704" y="84.042" width="25.361" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="54.943" y="39.279" width="64.113" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="20.937" y="39.279" width="16.959" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="392.95" y="39.279" width="16.023" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="418.064" y="39.279" width="73.004" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="274.174" y="342.742" width="14.984" height="30.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="222.838" y="342.742" width="14.984" height="30.333"/>
	</g>
</g>
<g>
	<g>
		<rect x="151.372" y="410.871" width="27.499" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="65.372" y="410.871" width="73.004" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="65.372" y="433.368" width="27.5" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="105.88" y="433.368" width="73.004" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="419.752" y="410.871" width="27.5" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="333.752" y="410.871" width="73.004" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="333.752" y="433.368" width="27.499" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="374.25" y="433.368" width="73.004" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<path d="M316.243,48.15c-5.608-5.609-13.402-8.226-21.936-7.386c-7.983,0.79-15.732,4.577-21.819,10.666
			c-10.837,10.838-13.639,26.325-7.756,37.635l-5.422,5.422l-6.093-6.093c4.92-10.192,2.32-23.831-7.266-33.417l-18.788-18.788
			l-10.595,10.596l18.788,18.788c2.998,2.998,4.781,6.712,5.225,10.183l-26.492-26.492L203.493,59.86l26.493,26.493
			c-3.471-0.443-7.186-2.227-10.185-5.225l-18.788-18.789l-10.595,10.596l18.788,18.789c6.414,6.413,14.644,9.702,22.441,9.702
			c3.853,0,7.593-0.822,10.965-2.447l6.104,6.104l-33.072,33.072l10.595,10.596l33.074-33.073l33.073,33.073l10.595-10.596
			l-33.073-33.072l5.42-5.42c3.879,2.018,8.246,3.017,12.752,3.017c8.633,0,17.763-3.654,24.884-10.775
			c6.089-6.089,9.877-13.838,10.666-21.819C324.473,61.546,321.849,53.756,316.243,48.15z M308.716,68.609
			c-0.45,4.544-2.705,9.054-6.35,12.699c-7.006,7.007-17.339,8.507-22.563,3.283c-5.226-5.227-3.724-15.56,3.281-22.564
			c3.645-3.645,8.155-5.901,12.7-6.35c0.534-0.053,1.061-0.079,1.576-0.079c3.33,0,6.232,1.094,8.288,3.149
			C308.021,61.119,309.111,64.621,308.716,68.609z"/>
	</g>
</g>
<g>
	<g>
		<rect x="168.005" y="122.931" width="17.714" height="14.984"/>
	</g>
</g>
<g>
	<g>
		<rect x="222.838" y="383.959" width="14.984" height="13.442"/>
	</g>
</g>
<g>
	<g>
		<rect x="274.174" y="383.959" width="14.984" height="13.442"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
</template>
